import React, { useEffect } from 'react'
import { initFbSDK } from '../helpers/fb';

const FbProvider = ({ children }) => {
    useEffect(() => {
        initFbSDK();
    }, []);
    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    )
}

export default FbProvider
